import axios from 'axios';

  const instance = axios.create({
        baseURL: 'http://zircon.teccube.ly/api',
        header: { 'content-type': 'application/json'} 
    })
   
export default instance;